import { Link } from 'react-router-dom';

export default function AboutIntro() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-2/5">
            <span className="inline-block text-xs font-medium text-foreground-500 border border-background-300 rounded-full px-3 py-1 mb-6">
              关于我们
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-2 leading-tight">
              打造最优质的
            </h2>
            <h2 className="text-2xl md:text-3xl font-heading font-light text-secondary-500 mb-8 leading-tight">
              韩漫在线阅读平台 <span className="text-lg">📚</span>
            </h2>
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 max-w-md">
              韩国漫画网成立于2020年，专注为全球华语漫迷提供高质量韩国漫画在线阅读服务。我们与多家韩国漫画平台合作，拥有超过5000部正版韩漫资源，涵盖恋爱、热血、悬疑、都市、奇幻等全部分类。
            </p>
            <Link
              to="/about"
              className="inline-flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 border-b border-primary-300 hover:border-primary-500 transition-colors pb-0.5 whitespace-nowrap cursor-pointer"
            >
              了解更多关于我们
              <i className="ri-arrow-right-line text-xs"></i>
            </Link>
          </div>

          <div className="lg:w-3/5">
            <div className="flex items-start gap-6 mb-8">
              <div className="text-right">
                <div className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">
                  5000<span className="text-primary-500">+</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">漫画资源</p>
              </div>
              <div className="text-right">
                <div className="text-4xl md:text-5xl font-heading font-bold text-foreground-950">
                  50<span className="text-primary-500">万+</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">活跃用户</p>
              </div>
            </div>

            <div className="relative">
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full aspect-[4/5] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20minimalist%20illustration%2C%20peaceful%20reading%20scene%20with%20warm%20cozy%20atmosphere%2C%20soft%20natural%20light%20from%20window%2C%20clean%20simple%20composition%2C%20cream%20and%20beige%20color%20palette%2C%20no%20text%2C%20artistic%20editorial%20style%2C%20high%20quality%20digital%20art&width=500&height=625&seq=about-img-01&orientation=portrait"
                    alt="舒适的阅读体验"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full aspect-[3/4] rounded-lg overflow-hidden mt-8">
                  <img
                    src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20minimalist%20illustration%2C%20digital%20reading%20device%20displaying%20colorful%20comic%20art%2C%20modern%20cozy%20interior%20background%2C%20warm%20ambient%20lighting%2C%20clean%20composition%2C%20cream%20and%20warm%20gray%20color%20palette%2C%20no%20text%2C%20high%20quality%20digital%20art&width=500&height=667&seq=about-img-02&orientation=portrait"
                    alt="高清韩漫阅读"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}